// This module is explicitly mocked for vitest in setupEnv.ts
// Make sure the mock is updated if you make changes here

import type { LoggerClient } from "@getbread/wheat-logger";
import { getConfig } from "./getConfig";

export const isProductionMode = (): boolean => import.meta.env.PROD;
export const getLogLevel = (): keyof LoggerClient =>
	import.meta.env.VITE_LOG_LEVEL ?? getConfig("loglevel");

export const isDevelopmentMode = (): boolean => import.meta.env.DEV;
export const isMirageEnabled = (): boolean =>
	import.meta.env.VITE_API_MOCK_MIRAGE === "true" && !import.meta.env.VITE_API_URL;
